module.exports = __webpack_public_path__ + "img/svg/phone.7c1a70d4126e4d602f0c9028497f484d.svg";